var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderOverviewPage',{attrs:{"i18n-prefix":"tableOrder","config-key":"TABLE_ORDER","retrieve-order-options":_vm.retrieveOrderOptions,"confirm-dialog-message-args-builder":_vm.buildConfirmDialogMessageArgs,"before-new-order":_vm.clearBasketBeforeNewOrder}})
}
var staticRenderFns = []

export { render, staticRenderFns }